(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["pp-bundle-breaks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-bundle')) {
    customElements.define(
      'pp-bundle',
      class extends HTMLElement {
        connectedCallback() {
          this.data = JSON.parse(this.querySelector('[data-pp-product]').textContent);
          this.addEventListener('change', (e) => {
            if (e.target.matches('input[type=radio]')) this.select(e.target.closest('.pp-tier'));
            this.refresh();
          });
          this.querySelector('[data-atc]').addEventListener('click', () => this.add());
          this.refresh();
        }

        formatMoney(cents) {
          const format = this.data.moneyFormat;
          if (!format) return (cents / 100).toFixed(2);
          const group = (n, dec, thou, sep) => {
            const [i, f] = (n / 100).toFixed(dec).split('.');
            return i.replace(/\B(?=(\d{3})+(?!\d))/g, thou) + (f ? sep + f : '');
          };
          return format.replace(/\{\s*\{\s*(\w+)\s*\}\s*\}/, (_, key) => {
            switch (key) {
              case 'amount_no_decimals': return group(cents, 0, ',', '.');
              case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
              case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
              case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
              default: return group(cents, 2, ',', '.');
            }
          });
        }

        select(tier) {
          this.querySelectorAll('.pp-tier').forEach((t) => t.classList.toggle('is-selected', t === tier));
        }

        variantFor(item) {
          const values = [...item.querySelectorAll('select')].map((s) => s.value);
          return this.data.variants.find((v) => v.options.every((o, i) => o === values[i]));
        }

        tierVariants(tier) {
          const items = tier.querySelectorAll('.pp-tier__item');
          if (!items.length) return Array.from({ length: Number(tier.dataset.qty) }, () => this.data.variants[0]);
          return [...items].map((i) => this.variantFor(i));
        }

        refresh() {
          this.querySelectorAll('.pp-tier').forEach((tier) => {
            const vs = this.tierVariants(tier);
            if (vs.some((v) => !v)) return;
            const pct = Number(tier.dataset.discount) || 0;
            const price = vs.reduce((s, v) => s + v.price - Math.floor((v.price * pct) / 100), 0);
            const compare = vs.reduce((s, v) => s + Math.max(v.compare, v.price), 0);
            tier.querySelector('[data-price]').textContent = this.formatMoney(price);
            tier.querySelector('[data-compare]').textContent = this.formatMoney(compare);
            tier.querySelector('[data-saved]').textContent = this.formatMoney(compare - price);
          });
          const tier = this.querySelector('.pp-tier.is-selected');
          const vs = tier ? this.tierVariants(tier) : [];
          this.querySelector('[data-atc]').disabled = !(vs.length && vs.every((v) => v && v.available));
        }

        async add() {
          const tier = this.querySelector('.pp-tier.is-selected');
          if (!tier) return;
          const btn = this.querySelector('[data-atc]');
          const err = this.querySelector('[data-error]');
          const counts = new Map();
          this.tierVariants(tier).forEach((v) => counts.set(v.id, (counts.get(v.id) || 0) + 1));
          // Shopify lists the most recently added line first, so add-ons go in first (reversed) and the hoodies last:
          // the cart then reads hoodie, shipping protection, mystery box, like the competitor.
          const addons = [...this.querySelectorAll('[data-addon]:checked')].map((a) => ({ id: Number(a.value), quantity: 1 })).reverse();
          const items = [...addons, ...[...counts].map(([id, quantity]) => ({ id, quantity }))];
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const mode = this.dataset.afterAdd || 'drawer';
          const drawer = document.querySelector('theme-drawer#cart-drawer');
          const useDrawer = mode === 'drawer' && !!drawer;
          const sectionIds = [...document.querySelectorAll('cart-items-component[data-section-id]')].map((el) => el.dataset.sectionId);
          btn.disabled = true;
          err.hidden = true;

          // Same event Horizon's own add-to-cart sends: the cart drawer, cart icon and cart items listen to it.
          let events = null;
          let deferred = null;
          if (useDrawer) {
            try {
              events = await import('@shopify/events');
              deferred = events.CartLinesUpdateEvent.createPromise();
              this.dispatchEvent(
                new events.CartLinesUpdateEvent({
                  action: 'add',
                  context: 'product',
                  lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
                  promise: deferred.promise,
                })
              );
            } catch (e) {
              events = null;
              deferred = null;
            }
          }

          try {
            const payload = useDrawer && sectionIds.length ? { items, sections: sectionIds.join(','), sections_url: window.location.pathname } : { items };
            const res = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify(payload),
            });
            const json = await res.json();
            if (!res.ok) throw new Error(json.description || json.message || 'Could not add to cart');

            if (!useDrawer) {
              window.location.href = mode === 'checkout' ? `${root}checkout` : `${root}cart`;
              return;
            }

            const cart = await (await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } })).json();
            if (events && deferred) {
              let cartModel = cart;
              try { cartModel = events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart); } catch (e) {}
              deferred.resolve({
                cart: cartModel,
                detail: { sections: json.sections || {}, items: json.items, itemCount: cart.item_count, source: 'pp-bundle', didError: false },
              });
            } else {
              // No event support: refresh the drawer markup ourselves.
              const html = await (await fetch(`${root}?sections=cart-drawer-section`)).json();
              const fresh = new DOMParser().parseFromString(html['cart-drawer-section'] || '', 'text/html').querySelector('.cart-drawer__inner');
              const current = drawer.querySelector('.cart-drawer__inner');
              if (fresh && current) current.replaceWith(fresh);
            }
            setTimeout(() => {
              if (!drawer.isOpen && typeof drawer.open === 'function') drawer.open();
            }, 350);
            btn.disabled = false;
          } catch (e) {
            if (deferred) deferred.reject(e);
            if (!useDrawer) {
              err.textContent = e.message;
              err.hidden = false;
            } else {
              err.textContent = e.message;
              err.hidden = false;
            }
            btn.disabled = false;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-delivery-timeline"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-delivery-timeline')) {
    customElements.define(
      'pp-delivery-timeline',
      class extends HTMLElement {
        connectedCallback() {
          const skip = this.dataset.skipWeekends === 'true';
          const months = (this.dataset.months || 'Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec').split(',').map((m) => m.trim());
          const add = (n) => {
            const d = new Date();
            let left = n;
            while (left > 0) {
              d.setDate(d.getDate() + 1);
              if (!skip || (d.getDay() !== 0 && d.getDay() !== 6)) left--;
            }
            return d;
          };
          const ordinal = (n) => {
            const v = n % 100;
            if (v >= 11 && v <= 13) return `${n}th`;
            return n + ({ 1: 'st', 2: 'nd', 3: 'rd' }[n % 10] || 'th');
          };
          const fmt = (d) => `${months[d.getMonth()]} ${ordinal(d.getDate())}`;
          this.querySelectorAll('.pp-delivery__date').forEach((el) => {
            const min = parseInt(el.dataset.min, 10) || 0;
            const max = parseInt(el.dataset.max, 10) || 0;
            el.textContent = min === max ? fmt(add(min)) : `${fmt(add(min))} - ${fmt(add(max))}`;
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pp-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pp-sticky-atc')) {
    customElements.define(
      'pp-sticky-atc',
      class extends HTMLElement {
        connectedCallback() {
          const target = document.querySelector('pp-bundle [data-atc]') || document.querySelector('pp-bundle');
          if (target && 'IntersectionObserver' in window) {
            new IntersectionObserver(([entry]) => {
              this.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
            }).observe(target);
          } else {
            this.hidden = false;
          }
          const select = this.querySelector('[data-sticky-select]');
          const btn = this.querySelector('[data-sticky-add]');
          if (select) {
            select.addEventListener('change', () => {
              btn.dataset.variant = select.value;
              const opt = select.selectedOptions[0];
              const price = this.querySelector('[data-sticky-price]');
              if (opt && price) price.textContent = opt.dataset.price;
            });
          }
          btn.addEventListener('click', () => this.onClick(btn));
        }

        async onClick(btn) {
          const bundle = document.querySelector('pp-bundle');
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          if (bundle && (isMobile || this.dataset.mode === 'scroll_always')) {
            bundle.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          btn.disabled = true;
          try {
            const res = await fetch(`${root}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }),
            });
            if (!res.ok) throw new Error((await res.json()).description || 'Error');
            window.location.href = `${root}cart`;
          } catch (e) {
            btn.disabled = false;
            alert(e.message);
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
